import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import { Image } from 'primereact/image';
import { Message } from 'primereact/message';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import { _endPoints } from '../Helper/links';
import logo_svg from "../public/images/logo.svg";
import imgCustomer from "../public/images/user.avif";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import API from '../Helper/server/API';
import pattern from '../Helper/pattern';

function CustomerShowComponet(props) {
    const [state, set_state] = useState(props?.customer?.state);
    const [selected_check, set_selected_check] = useState(
        props?.customer?.check === 1 ? { name: 'أنتظار التحقق', check: 1 } :
            props?.customer?.check === 2 ? { name: 'بيانات غير مطابقة', check: 2 } :
                props?.customer?.check === 3 ? { name: 'تم التحقق', check: 3 } : { name: 'أنتظار ادخال البيانات', check: 0 }
    );
    const [loading, setLoading] = useState(false);
    const list_check = [
        { name: 'أنتظار ادخال البيانات', check: 0 },
        { name: 'أنتظار التحقق', check: 1 },
        { name: 'بيانات غير مطابقة', check: 2 },
        { name: 'تم التحقق', check: 3 },
    ];
    const body_check = (value) => {
        return <>
            {value.check === 0 && <Message severity="info" icon="pi pi-clock p-0 m-0  ml-2" text="انتظار ادخال البيانات" />}
            {value.check === 1 && <Message severity="warn" icon="pi pi-clock p-0 m-0  ml-2" text="انتظار التحقق" />}
            {value.check === 2 && <Message severity="error" icon="pi pi-times p-0 m-0  ml-2" text="بيانات غير مطابقة" />}
            {value.check === 3 && <Message severity="success" icon="pi pi-check p-0 m-0  ml-2" text="تم التحقق" />}
        </>
    }

    const UpdateCustomerApp = async (e) => {
        setLoading(true);
        var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if (!state && state !== 0 && state !== 1 && state !== false && state !== true) {
            validtion = false
            document.getElementById("lstate").style.color = 'red';
        }
        if (!pattern.number_int.test(selected_check?.check)) {
            validtion = false
            document.getElementById("lcheck").style.color = 'red';
        }
        if (!validtion) {
            props?.toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.1rem"
                },
                severity: 'error', summary: 'خطــاء', detail: "أرجــو إدخــال بيــانات العميــل", life: 5000
            });
        }
        else {
            const data = {
                id_customer: props?.customer?.ID_customer,
                state: state,
                check: selected_check?.check
            }
            const response = await API.post(_endPoints.customers.app_update, data)
            if (response?.success) {
                props?.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'success', summary: ' نجــاح ', detail: response?.msg
                });
                props?.set_show_customer(false)
                props?.GetCustomers()
            }
            else if (response?.success === 0) {
                props?.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.error === "check")
                    document.getElementById("lcheck").style.color = "red"
                else if (response?.error === "state")
                    document.getElementById("lstate").style.color = "red"
            }
        }
        setLoading(false);
    }
    return (
        <div className="ibox" >
            <div class="row">
                <div class="col-md-12">
                    <div className="row font-15">
                        <div className="col-md-12 " >
                            <div className="font-bold mt-4 " ></div>
                            <div className='row'>
                                <div className='col-md-2 pt-5'>
                                    <div class="media-img">
                                        <center>
                                            <Avatar image={props?.customer?.image ? `${_endPoints.users.images}${props?.customer?.image}` : imgCustomer} className="flex mr-2" size="xlarge" style={{ width: "150px", height: "150px", transition: "transform 10s ease" }} shape="circle" />
                                        </center>
                                    </div>
                                </div>

                                <div className='col-md-10'>

                                    <hr></hr>
                                    <br></br>
                                    <div className='row'>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="ti-user font-26 text-muted ml-3" dir='rtl'></i>
                                                {props?.customer?.visitor_name ? <>{props?.customer?.visitor_name}</> : <>-</>}
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-phone font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>  {props?.customer?.phone_number ? <>{props?.customer?.phone_number}  <small class=" text-muted" dir='ltr' > +218 </small></> : <>-</>}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-whatsapp font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.whatsapp_number && props?.customer?.whatsapp_number !== 'null' ? <>{props?.customer?.whatsapp_number} +</> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <br></br>
                                    <div className='row'>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-key font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.national_number ? <>{props?.customer?.national_number} </> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <i class="fa fa-map font-26 text-muted ml-3 pt-1"></i>
                                                <p style={{ display: "inline" }}>
                                                    {props?.customer?.name_city ? <>{props?.customer?.name_city}</> : <>-</>}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12  mb-4 font-bold" >
                                            <div class="media-heading font-16" >
                                                <img src={logo_svg} alt='app' width={30} height={30} class="font-26 text-muted ml-3"></img>
                                                <p style={{ display: "inline" }}>  {props?.customer?.ID_customer ? props?.customer?.id_user ? <>مشتــرك</> : <>غيــر مشتــرك</> : <>-</>}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr></hr>
                                    <br></br>

                                    <div className='row'>
                                        <div className="col-md-3 col-3  mb-4 font-bold" >
                                            <label id='lstate' className='font-bold'>حالة الحساب</label>
                                            <br></br>
                                            <Button icon={state ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={state ? "فعـــال" : "متــوقف"} outlined severity={state ? "success" : "danger"} size="large" className='mr-1'
                                                onClick={(e) => {
                                                    if (state)
                                                        set_state(0)
                                                    else
                                                        set_state(1)
                                                    document.getElementById("lstate").style.color = 'black';
                                                    // document.getElementById("lstate").style.color = 'black';
                                                }} />
                                        </div>
                                        <div className="col-md-3 col-3  mb-4 font-bold" >
                                            <label id='lcheck' className='font-bold'>ملف المستخدم</label>
                                            <br></br>
                                            <Dropdown value={selected_check} onChange={(e) => set_selected_check(e.value)} options={list_check} optionLabel="name"
                                                placeholder="اختر حالة ملف المستخدم" className="w-full col-md-12" emptyMessage='لا يوجد عناصر' itemTemplate={body_check} valueTemplate={body_check} panelClassName='p-0 m-0' />
                                        </div>
                                        <div className="col-md-6 col-6  mb-4 font-bold" >
                                            <i class="fa fa-warning font-26 text-muted ml-3 pt-1"></i>
                                            <p style={{ display: "inline" }} class="font-13 ">{props?.customer?.note ? <>{props?.customer?.note} </> : <>-</>}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-12 col-12'>
                                    <Accordion activeIndex={0} >

                                        <AccordionTab header='شهادة وضع العائلي'  >
                                            <center>
                                                <table className="table table-bordered m-0 p-0">
                                                    <tr >
                                                        <th style={{ textAlign: "center", width: "30%" }}>
                                                            <h6 >  رقم قيد العائلة </h6>
                                                        </th>
                                                        <th style={{ textAlign: "right" }}>
                                                            <h6 > {props?.customer?.value_key} </h6>
                                                        </th>
                                                    </tr>
                                                    <tr >
                                                        <th style={{ textAlign: "center" }} colSpan={2}>
                                                            <Image src={_endPoints.customers.files + props?.customer?.path_document} alt="Image" width="100%" preview
                                                                onError={(e) => {
                                                                    e.target.src = imgCustomer;
                                                                }}
                                                            />
                                                        </th>
                                                    </tr>
                                                </table>
                                            </center>
                                        </AccordionTab>


                                    </Accordion>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <center>
                                    <Button label="إغـــلاق" severity="danger" outlined icon="pi pi-times ml-2" onClick={(e) => props?.set_show_customer(false)} />
                                    <Button label="تعــديل" severity="success" outlined icon="pi pi-check ml-2" onClick={UpdateCustomerApp} loading={loading} className='mr-2' />


                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerShowComponet